<cv-loader size="large" [overlay]="true" *ngIf="loading"></cv-loader>

<div class="da-edit-container h-100 w-100 p-2" *ngIf="activeSelection !== null && !this.noPermission">
    <ng-container [ngSwitch]="showPermissionWarning">
        <!-- Write access warning dialog -->
        <div class="da-permission-warning" *ngSwitchCase="AssignmentPermissions.Write">
            <h1 cvLocalizedText langSection="Assign_Tool" langKey="Attention">Attention!</h1>
            <p cvLocalizedText langSection="Assign_Tool" langKey="Write_Warning">Templates use the original creator's permissions and could be different than the ones you are sharing. Any changes made will only be reflected in new versions.</p>
            <button type="button" class="btn btn-secondary" (click)="acceptWarningForPermission(AssignmentPermissions.Write)">
                <span cvLocalizedText langSection="Assign_Tool" langKey="Okay_button">Okay</span>
            </button>
        </div>
        <!-- Read with Control access warning dialog -->
        <div class="da-permission-warning" *ngSwitchCase="AssignmentPermissions.ReadControl">
            <h1 cvLocalizedText langSection="Assign_Tool" langKey="Attention">Attention!</h1>
            <p cvLocalizedText langSection="Assign_Tool" langKey="ReadControl_Warning">ReadControl Warning.</p>
            <button type="button" class="btn btn-secondary" (click)="acceptWarningForPermission(AssignmentPermissions.ReadControl)">
                <span cvLocalizedText langSection="Assign_Tool" langKey="Okay_button">Okay</span>
            </button>
        </div>
        <!-- Template sharing warning dialog -->
        <div class="da-permission-warning" *ngSwitchCase="AssignmentPermissions.Template">
            <h1 cvLocalizedText langSection="Assign_Tool" langKey="Attention">Attention!</h1>
            <p cvLocalizedText langSection="Assign_Tool" langKey="Template_Warning">Template Warning.</p>
            <button type="button" class="btn btn-secondary" (click)="acceptWarningForPermission(AssignmentPermissions.Template)">
                <span cvLocalizedText langSection="Assign_Tool" langKey="Okay_button">Okay</span>
            </button>
        </div>
    </ng-container>

    <!-- Login assignment -->
    <div class="h-100" *ngIf="selectedIsLogin(activeSelection)" [hidden]="showPermissionWarning !== AssignmentPermissions.None">
        <div class="h-100 d-flex flex-column">
            <div class="lato-bold font-size-16 mb-2">{{ activeSelection.LoginName }}</div>
            <div class="mt-1">
                <select class="form-control w-auto pr-5" [(ngModel)]="activeSelectionPermission" (ngModelChange)="showWarningForActivePermission()">
                    <option [value]="AssignmentPermissions.None">
                        <span cvLocalizedText langSection="Assign_Tool" langKey="None">None</span>
                    </option>
                    <option [value]="AssignmentPermissions.Read">
                        <span cvLocalizedText langSection="Assign_Tool" langKey="Read">Read</span>
                    </option>
                    <option [value]="AssignmentPermissions.ReadGroup">
                        <span cvLocalizedText langSection="Assign_Tool" langKey="Read_Group">Read with Group Nav</span>
                    </option>
                    <option [value]="AssignmentPermissions.ReadControl">
                        <span cvLocalizedText langSection="Assign_Tool" langKey="ReadControl">ReadControl</span>
                    </option>
                    <option [value]="AssignmentPermissions.Write">
                        <span cvLocalizedText langSection="Assign_Tool" langKey="Write">Write</span>
                    </option>
                    <option [value]="AssignmentPermissions.Template">
                        <span cvLocalizedText langSection="Assign_Tool" langKey="Template">Template</span>
                    </option>
                </select>
            </div>
            <div class="d-flex justify-content-end mt-auto pt-2 border-top border-valyrianSteel">
                <button type="button" class="btn btn-text mr-2" (click)="deselect()">
                    <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
                </button>
                <button type="button" class="btn btn-primary" (click)="save()" [disabled]="loading">
                    <span cvLocalizedText langSection="Common" langKey="Save_Button">Save</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Role assignment -->
    <div class="h-100" *ngIf="!selectedIsLogin(activeSelection)" [hidden]="showPermissionWarning !== AssignmentPermissions.None">
        <div class="d-flex h-100 flex-column">
            <div *ngIf="selectedIsGroup(activeSelection)" class="mb-2 lato-bold font-size-16">{{ activeSelection.GroupName }}</div>
            <div *ngIf="selectedIsAgentAttribute(activeSelection)" class="mb-2 lato-bold font-size-16">{{ activeSelection.AttributeValueName }}</div>
            <!-- <%-- Search --%>
            <div class="mb-2">
                <div class="sgInputFilterContainer">
                    <div class="search-box live-search">
                        <input type="search" class="form-control form-control-sm" cvLocalizedText
                        langSection="Assign_Tool" langKey="Search" placeholder="Search"
                        ng-model="$ctrl.filterValue" ng-model-options="{ debounce: 400 }"
                        ng-change="$ctrl.applyFilter();" autocomplete="off"/>
                        <span class="clear-input" data-ng-show="$ctrl.filterValue.length > 0" ng-click="$ctrl.clearFilter()"></span>
                    </div>
                </div>
            </div> -->
            <div class="flex-fill">
                <ag-grid-angular *ngIf="gridOptions"
                    class="h-100 flex-grow-1 overflow-auto ag-theme-balham ag-basic"
                    [gridOptions]="gridOptions"
                    [rowData]="activeSelectionProfiles"
                ></ag-grid-angular>
            </div>
            <div class="d-flex justify-content-end flex-nowrap mt-2">
                <button type="button" class="btn btn-text mr-2" (click)="deselect()">
                    <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
                </button>
                <button type="button" class="btn btn-primary" (click)="save()">
                    <span cvLocalizedText langSection="Common" langKey="Save_Button">Save</span>
                </button>
            </div>
        </div>
    </div>

</div>

<!-- View Assignments -->
<div class="shareDashScrollbox" *ngIf="!noPermission">
    <div *ngIf="!activeSelection" class="p-2">
        <ng-container *ngFor="let assignment of displayLists | keyvalue">
            <div *ngIf="assignment.value.items.logins.length > 0 || assignment.value.items.groups.size > 0 || assignment.value.items.attributes.size > 0">
                <div class="font-size-14 bold">{{ assignment.value.title }}</div>
                <!-- Group Assignments -->
                <div *ngFor="let g of assignment.value.items.groups | keyvalue" class="da-assignment-group w-100 p-2 my-2 rounded bg-greekToMe" [ngClass]="'da-assignment-' + assignment.key">
                    <div class="d-flex justify-content-between">
                        <div class="bold">{{ g.value.group.GroupName }}</div>
                        <div class="d-flex">
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="edit(g.value.group)">
                                <svg class="icon-16">
                                    <use href="../../../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                                </svg>
                            </button>
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="remove(g.value.group, assignment.value.permission)">
                                <svg class="icon-16">
                                    <use href="../../../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div *ngFor="let role of g.value.roles" class="pl-6">
                        <div>{{ role.ProfileName }}</div>
                    </div>
                </div>
                <!-- Attribute Assignments -->
                <div *ngFor="let a of assignment.value.items.attributes | keyvalue" class="da-assignment-agent-attr w-100 p-2 my-2 rounded bg-greekToMe">
                    <div class="d-flex justify-content-between">
                        <div class="bold">{{ a.value.attribute.AttributeValueName }}</div>
                        <div class="d-flex">
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="edit(a.value.attribute)">
                                <svg class="icon-16">
                                    <use href="../../../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                                </svg>
                            </button>
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="remove(a.value.attribute, assignment.value.permission)">
                                <svg class="icon-16">
                                    <use href="../../../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div *ngFor="let role of a.value.roles" class="pl-6">
                        <div>{{ role.ProfileName }}</div>
                    </div>
                </div>
                <!-- Login Assignments -->
                <div *ngIf="assignment.value.items.logins.length > 0" class="w-100 p-2 my-2 rounded bg-greekToMe">
                    <div class="d-flex justify-content-between">
                        <div cvLocalizedText langSection="Assign_Tool" langKey="Logins">Logins</div>
                    </div>
                    <div *ngFor="let login of assignment.value.items.logins" class="da-assignment-login d-flex justify-content-between font-size-12 ml-2 mt-1 pl-4">
                        <div class="bold">{{ login.LoginName }}</div>
                        <div class="d-flex">
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="edit(login)">
                                <svg class="icon-16">
                                    <use href="../../../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                                </svg>
                            </button>
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="remove(login, assignment.value.permission)">
                                <svg class="icon-16">
                                    <use href="../../../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
